import { render, staticRenderFns } from "./TeamStudentStatisticsComponent.vue?vue&type=template&id=5db0051e&"
import script from "./TeamStudentStatisticsComponent.vue?vue&type=script&lang=js&"
export * from "./TeamStudentStatisticsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports